module.exports = __webpack_public_path__ + "static/media/contact.4219fb2c.jpg";